/**
 * Campaign Lookups — types mirror the schema in
 * database/migrations/2026-05-09-001-campaign-lookups.sql
 */

export type LookupColumnRole = "key" | "value" | "rule";

export interface LookupColumn {
  name: string;
  role?: LookupColumnRole;
  order?: number;
}

export interface CampaignLookup {
  id: string;
  name: string;
  description: string | null;
  key_column: string;
  column_schema: LookupColumn[];
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface CampaignLookupRow {
  id: string;
  lookup_id: string;
  key_value_normalized: string;
  key_value_display: string;
  data: Record<string, unknown>;
  is_default: boolean;
  row_order: number;
  created_at: string;
  updated_at: string;
}

export interface CreateLookupInput {
  name: string;
  description?: string | null;
  key_column: string;
  column_schema: LookupColumn[];
}

export interface UpdateLookupInput {
  name?: string;
  description?: string | null;
}

/** Shape passed to replace_lookup_rows RPC. */
export interface LookupRowUploadRow {
  data: Record<string, unknown>;
  is_default?: boolean;
}

/** Hard caps enforced by the replace_lookup_rows RPC. Mirrored here so
 *  the CSV upload modal can validate before round-tripping. */
export const LOOKUP_CAPS = {
  MAX_ROWS: 2000,
  MAX_COLUMNS: 20,
  MAX_FILE_SIZE_BYTES: 256 * 1024,
} as const;
